import { ICourseStudentsSummary } from '@/types/views/student.types';
import { useMemo } from 'react';
import { queryKeys } from './queryKeys';
import { useAppQuery } from './useAppQuery';

export const useGetCourseStudentsSummary = (
  courseId: string | undefined,
  searchText?: string,
  enabled: boolean = true
) => {

  const params = useMemo(() => ({ searchText: searchText?.trim() || undefined }), [searchText]);

  return useAppQuery<ICourseStudentsSummary>(
    `/TrainingManager/courses/${courseId}/students/summary`,
    {
      enabled: !!courseId && enabled,
      placeholderData: undefined,
      queryKey: queryKeys.courseStudents.summary(courseId, params),
      config: {
        params,
      },
    }
  );
};
